import { Component, OnInit } from '@angular/core';

// Services
import { MapserviceService } from '../services/map-services.service';
import { UtilitiesService } from '../services/utilities-services.service';
import { PrintService } from '../services/print-services.service';

// Esri
import Graphic from '@arcgis/core/Graphic';
import Draw from '@arcgis/core/views/draw/Draw';
import * as Print from "@arcgis/core/rest/print";
import PrintTemplate from '@arcgis/core/rest/support/PrintTemplate';
import PrintParameters from '@arcgis/core/rest/support/PrintParameters';
import FeatureLayer from '@arcgis/core/layers/FeatureLayer';
import * as intl from '@arcgis/core/intl';
import { environment } from 'src/environments/environment';



@Component({
  selector: 'app-print',
  templateUrl: './print.component.html',
  styleUrls: ['./print.component.scss']
})
export class PrintComponent implements OnInit {

  // Map
  view;
  map;
  basinSelected;
  queryBasins;
  draw;

  // Toggle print
  togglePrint: boolean;
  displayType = 'none';
  loggedIn;

  // Print div active
  showDiv = {
    printMain : true,
    mapRpt : false,
    basinRpt : false,
    waitMsg : false,
    errorMsg : false,
    finishedMsg: false
  };

  // Map report
  userComms = '';
  basinNM = 'none';
  pointCollect = false;
  printMapLayout = false;
  printMapPointSelected = false; // Checks if map point is selected, disables button to generate report if false
  reportURL = '';

  // Basin report
  basinFeature: []; // Basin query feature result(s)
  basinPointCollect = false;
  printBasinLayout = false;
  basinStuff;
  selDowlknum;
  printBasinSelected = false; // Checks if basin is selected, disables button to generate report if false

  // Basin report variables
  elev10;
  elev25;
  elev50;
  elev100;
  elev500;
  studyDatum;
  county;
  studyDate;
  studySource;
  studyName;
  ohwl;
  highestRec;
  highestRecDt;
  datum;

  constructor(private mapService: MapserviceService, private utilitiesService: UtilitiesService, private printService: PrintService) { }

  ngOnInit() {

    /* Map view subscription */
    this.mapService.view.subscribe(result => {
      this.view = result;
    });

    /* Map Report user comments subscription */
    this.printService.userComments.subscribe(result => {
      this.userComms = result;
    });

    /* Map report subscription to watch for point to be selected */
    this.printService.mapPointSelected.subscribe(result => {
      this.printMapPointSelected = result;
    });

    /* Basin report subscription to watch for basin to be selected */
    this.printService.basinSelected.subscribe(result => {
      this.printBasinSelected = result;
    });

    /* Toggle Print subscription */
    // When toggled on (true) will display the print window
    // When toggled off (false) will not be displayed
    this.utilitiesService.togglePrint.subscribe(result => {
      this.togglePrint = result;
      if (result === true) {
        this.displayType = 'inline';
        this.utilitiesService.activateTable(false);
      } else {
        this.displayType = 'none';
        this.showPrintMain();
      }
    });

    /* Logged in subscription */
    // When toggled, update the showDiv printMain to be viewable
    this.utilitiesService.loggedIn.subscribe(result => {
      this.loggedIn = result;
      this.utilitiesService.activatePrint(false);
      this.showDiv.printMain = true;
      this.showDiv.mapRpt = false;
      this.showDiv.basinRpt = false;
    });

    /* Toggle map point graphic collection subscription */
    this.printService.mapPointGraphic.subscribe(result => {
      this.pointCollect = result;
      // If true, collect map graphic
      if (this.pointCollect === true) {
        this.enableCreatePoint();
      }
    });

    /* Print map report subscription */
    this.printService.printMapReport.subscribe(result => {
      this.printMapLayout = result;
      // If true, call to print map report
      if (this.printMapLayout === true) {
        debugger;
        this.printTheMapReport();
      }
    });

    /* Basin point collect subscription */
    this.printService.mapBasinPoint.subscribe(result => {
      this.basinPointCollect = result;
      // If true, collect the basin point selection
      if (this.basinPointCollect === true) {
        this.enableBasinPoint();
      }
    });

    /* Basin report subscription */
    this.printService.printBasinReport.subscribe(result => {
      this.printBasinLayout = result;
      // If true, print the basin report
      if (this.printBasinLayout === true) {
        this.printTheBasinReport();
      }
    });

    /* Basin Feature layer for basin query */
    this.queryBasins = new FeatureLayer({
      // url: 'https://gis.dnr.state.mn.us/host/rest/services/Hosted/DNR_Public_Waters_Delineations/FeatureServer/1'
      // url: 'https://gis.dnr.state.mn.us/appserver/rest/services/ewr/app_lake_flood_elevations/MapServer/1'
      url: environment.basinFloodUrl
    });

  }

  /* Clear the print window when user selects cancel button */
  onPrintCancel() {
    document.body.style.cursor = 'default';
    this.printService.basinSelectedStatus(false);
    this.printService.mapPointSelectedStatus(false);
    this.printService.activateBasinPointCollection(false);
    this.printService.activatePointCollection(false);
    this.pointCollect = false;
    this.view.graphics.removeAll();
    this.printService.userCommentsChange('');
    this.basinNM = 'none';
    this.view.popup.close();
    this.utilitiesService.activatePrint(false);
    this.draw.reset(); // Reset the draw class
  }

  /* Show Map Report in div */
  showMapReport() {
    this.showDiv.mapRpt = true;
    this.showDiv.printMain = false;
    this.showDiv.basinRpt = false;
    this.printService.activatePointCollection(true);
  }

  /* Show Basin Report in div */
  showBasinReport() {
    this.showDiv.basinRpt = true;
    this.showDiv.printMain = false;
    this.showDiv.mapRpt = false;
    this.printService.activateBasinPointCollection(true);
  }

  /* Show Print Main in div */
  showPrintMain() {
    this.showDiv.printMain = true;
    this.showDiv.mapRpt = false;
    this.showDiv.basinRpt = false;
    this.basinNM = 'none';
  }

  /* Map Report */
  // 1. Update map report user comments, and
  // 2. Update map report status
  printLFEOmapLayout() {
    this.printService.userCommentsChange(this.userComms);
    this.printService.activatePrintMapReport(true);
  }

  /* Basin Report */
  // 1. Update basin report status
  printLFEOBasinReport() {
    this.printService.activatePrintBasinReport(true);
  }

  /* Initiate drawing of the point */
  enableCreatePoint() {
    this.draw = new Draw({
      view: this.view
    });
    // Draw a point on mouse click
    const action = this.draw.create('point', { mode: 'click' });
    // PointDrawAction.draw-complete
    // Create a point when user clicks on the view or presses "C" key.
    action.on('draw-complete', event => {
      // On completion calls create point graphic
      this.createPointGraphic(event.coordinates);
    });
  }

  /* Add point graphic to the map */
  createPointGraphic(coordinates) {
    // Remove previous graphics
    this.view.graphics.removeAll();

    // Create point with coordinates from the click event
    const point = {
       type: 'point',
       x: coordinates[0],
       y: coordinates[1],
       spatialReference: this.view.spatialReference
     };

    // Set simple marker point symbol and symbol colors
    const symbol = {
      type: 'simple-marker',
      style: 'circle',
      color: [57, 255, 20],
      size: 15,
      outline: {
        width: 2,
        color: [0, 56, 101]
      }
    };

    // Create graphic point and symbol
    const graphic = new Graphic({
       geometry: point,
       symbol: symbol as any
    });
    this.view.graphics.add(graphic); // add graphic to map
    this.printService.mapPointSelectedStatus(true);
  }

  /*       ***        ***      */
  /* Map Report print service */
  /*       ***       ***     */
  async printTheMapReport() {
    // const printServiceUrl = 'https://gis.dnr.state.mn.us/appserver/rest/services/appUtilities/LFEOWebMapExport/GPServer/Export%20Web%20Map';

    // const printTask = new PrintTask({ url: printServiceUrl });
    
    try {
      this.showDiv.waitMsg = true;
      this.showDiv.finishedMsg = false;
      this.showDiv.errorMsg = false;
      // Show wait cursor
      document.body.style.cursor = 'wait';
      const today = new Date();
      debugger;

      // Set print template with custom elements
      const template = new PrintTemplate({
        layoutOptions: {
          customTextElements: [
            { date: 'Date: ' + today },
            { Comments: 'Comments: ' + this.userComms }
          ]
        },
      });
      // Set the template to automatically print the Map Report
      template.set('layout', 'LFEOmapReport');
      template.format = 'pdf';

      // Set print parameters with template and view
      const params = new PrintParameters({
        template: template as any,
        view: this.view
      });

      // Run the printTask with parameters and then display success or errors
      // Print.execute(environment.printMapReportUrl, params).then(printSuccess, printErr);
      var result = await Print.execute(environment.printMapReportUrl, params);
      console.log(result);
      if (result.url) {
        this.reportURL = result.url;
        this.showDiv.finishedMsg = true; 
        window.open(result.url)
      }
      else {
        this.showDiv.errorMsg = true;
      }
      // // On print success open a window containing the png
      // function printSuccess(result) {
      //   window.open(result.url);
      // }

      // // If print error then output error
      // function printErr(result) {
      //   console.log('Map Printing Error:');
      //   console.log(result);
      // }
    }
    catch (err) {
        console.log(err);
      }
    finally {
      this.showDiv.waitMsg = false;
      // Reset to default
      document.body.style.cursor = 'default';
    }
  }

  /*        ***         ***      */
  /* Basin Report print service */
  /*        ***        ***     */

  /* Watch for a click event in the basin report */
  enableBasinPoint() {
    this.view.on('click', event => {
      this.callQueryBasins(event.mapPoint, 'intersects');
    });
  }

  /* Basin query for Basin Report */
  callQueryBasins(point, spatialRelationship) {
    // Query object and assign attributes
    const query = this.queryBasins.createQuery();
    query.geometry = point;
    query.spatialRelationship = spatialRelationship;
    query.outFields = ['*'];
    query.returnGeometry = true;

    // Send query to the basin feature service query features method
    this.queryBasins.queryFeatures(query).then(result => {
      // Clear the basinFeature object
      this.basinFeature = [];
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < result.features.length; i++) {
        // If a basin is selected:
        // 1. Display the first record's (i) basin name in the drop-down menu, and (ii) assign the drop-down menu value to it's attributes
        // 2. Enable the print basin report button
        if (i === 0) {
          this.basinNM = result.features[i].attributes.pw_basin_name;
          this.basinStuff = result.features[i].attributes;
          this.printService.basinSelectedStatus(true);
        }
        // Collect all basins in an object for the basin selected drop-down menu
        (this.basinFeature as string[]).push(result.features[i]);
      }
      // If a user doesn't select a basin on the map, disable the print basin report button
      if (result.features.length === 0) {
        this.printService.basinSelectedStatus(false);
      }
    });
  }

  /* Print Basin Report */
  async printTheBasinReport() {
    // define the print service url and initiate the print task
    // const printServiceUrl = 'https://gis.dnr.state.mn.us/appserver/rest/services/appUtilities/LFEObasinOnlyReport/GPServer/Export%20Web%20Map';
    // const printTask = new PrintTask({ url: printServiceUrl });
    // Set date variable and date format options
    try 
    {
      this.showDiv.waitMsg = true;
      this.showDiv.errorMsg = false;
      this.showDiv.finishedMsg = false;
      // Show wait cursor
      document.body.style.cursor = 'wait';
      
      const today = new Date();
      debugger;
      const dateFormatIntlOptions = intl.convertDateFormatToIntlOptions('short-date');
      // Set custom text variables
      if (this.basinStuff.elevation_feet_10_year_flood) {
        this.elev10 = this.basinStuff.elevation_feet_10_year_flood.toFixed(1);
      } else {
        this.elev10 = 'Not Available';
      }
      if (this.basinStuff.elevation_feet_25_year_flood) {
        this.elev25 = this.basinStuff.elevation_feet_25_year_flood.toFixed(1);
      } else {
        this.elev25 = 'Not Available';
      }
      if (this.basinStuff.elevation_feet_50_year_flood) {
        this.elev50 = this.basinStuff.elevation_feet_50_year_flood.toFixed(1);
      } else {
        this.elev50 = 'Not Available';
      }
      if (this.basinStuff.elevation_feet_100_year_flood) {
        this.elev100 = this.basinStuff.elevation_feet_100_year_flood.toFixed(1);
      } else {
        this.elev100 = 'Not Available';
      }
      if (this.basinStuff.elevation_feet_500_year_flood) {
        this.elev500 = this.basinStuff.elevation_feet_500_year_flood.toFixed(1);
      } else {
        this.elev500 = 'Not Available';
      }
      if (this.basinStuff.vertical_datum) {
        this.studyDatum = this.basinStuff.vertical_datum;
      } else {
        this.studyDatum = 'Not Available';
      }
      if (this.basinStuff.cty_name) {
        this.county = this.basinStuff.cty_name;
      } else {
        this.county = 'Not Available';
      }
      if (this.basinStuff.study_date) {
        // Format date so date output in report is readable
        this.studyDate = intl.formatDate(this.basinStuff.study_date, dateFormatIntlOptions);
      } else {
        this.studyDate = 'Not Available';
      }
      if (this.basinStuff.source_type) {
        this.studySource = this.basinStuff.source_type;
      } else {
        this.studySource = 'Not Available';
      }
      if (this.basinStuff.study_name) {
        this.studyName = this.basinStuff.study_name;
      } else {
        this.studyName = 'Not Available';
      }
      if (this.basinStuff.ohwl_elevation_feet) {
        this.ohwl = this.basinStuff.ohwl_elevation_feet;
      } else {
        this.ohwl = 'Not Available';
      }
      if (this.basinStuff.highest_recorded_feet) {
        this.highestRec = this.basinStuff.highest_recorded_feet;
      } else {
        this.highestRec = 'Not Available';
      }
      if (this.basinStuff.highest_recorded_date) {
        // Format date so date output in report is readable
        this.highestRecDt = intl.formatDate(this.basinStuff.highest_recorded_date, dateFormatIntlOptions);
      } else {
        this.highestRecDt = 'Not Available';
      }
      if (this.basinStuff.ohwl_vertical_datum) {
        this.datum = this.basinStuff.ohwl_vertical_datum;
      } else {
        this.datum = 'Not Available';
      }

      // Set Basin Report template with custom elements
      const template = new PrintTemplate({
        layoutOptions: {
          customTextElements: [
            { date: 'Date: ' + today },
            { basinName: this.basinStuff.pw_basin_name + ' Elevation Report' },
            { basinID: 'DNR Basin ID: ' + this.basinStuff.dowlknum },
            { elev_10: '' + this.elev10 },
            { elev_25: '' + this.elev25 },
            { elev_50: '' + this.elev50 },
            { elev_100: '' + this.elev100 },
            { elev_500: '' + this.elev500 },
            { study_datum: '' + this.studyDatum },
            { county: '' + this.county },
            { study_date: '' + this.studyDate },
            { source: '' + this.studySource },
            { study_nm: '' + this.studyName },
            { ohwl: '' + this.ohwl },
            { highest_rec: '' + this.highestRec },
            { highest_rec_dt: '' + this.highestRecDt },
            { datum: '' + this.datum }
          ]
        }
      });
      // Set the template to automatically print the Basin Report
      template.set('layout', 'LFEObasinReport');
      template.format = 'pdf';

      // Set print parameters with template and view
      const params = new PrintParameters({
        template: template as any,
        view: this.view
      });

      // Run the printTask with parameters and then display success or errors
      // Print.execute(environment.printBasinReportUrl, params).then(printSuccess, printErr);
      var result = await Print.execute(environment.printBasinReportUrl, params);
      console.log(result);
      if (result.url) {
        this.reportURL = result.url;
        this.showDiv.finishedMsg = true; 
        window.open(result.url)
      }
      else {
        this.showDiv.errorMsg = true;
      }

      // // If print task is successful then open the png in another window
      // function printSuccess(result) {
      //   window.open(result.url);
      // }

      // // If print task errors then output error
      // function printErr(result) {
      //   console.log('Map Printing Error:');
      //   console.log(result);
      // }
    }
    catch (err) {
        console.log(err);
    }
    finally { 
      this.showDiv.waitMsg = false; 
      // Reset to default
      document.body.style.cursor = 'default';
    }
  }
}
